import { adminApiService } from './adminApi';
import { skillKnowledgeApiService } from './skillKnowledgeApi';
import { subscriptionApiService } from './subscriptionApi';
import { permissionsRolesApiService } from './permissionsRolesApi';
import { learningMgmtApiService } from './learningManagementApi';
import { notificationApiService } from './notificationApi';
import { promptApiService } from './promptApi';
import { paymentGatewayApiService } from './paymentGatewayApi';
import { paymentApiService } from './paymentApi';
import { profileApiService } from './profileApi';
import { apiService } from './api';

/**
 * Central registry of all API service instances.
 *
 * Both AuthContext (regular users) and AdminAuthContext (admin users)
 * use this to propagate tokens consistently across every service.
 */
const ALL_API_SERVICES = [
  apiService,
  adminApiService,
  skillKnowledgeApiService,
  subscriptionApiService,
  permissionsRolesApiService,
  learningMgmtApiService,
  notificationApiService,
  promptApiService,
  paymentGatewayApiService,
  paymentApiService,
  profileApiService,
];

/** Set or clear the auth token on every registered API service instance. */
export function setAllApiTokens(token: string | null): void {
  ALL_API_SERVICES.forEach((svc) => svc.setAuthToken(token));
}

/** Handlers for 401 (try refresh, then force logout so e.g. /profile redirects to login). */
type UnauthorizedHandler = () => Promise<string | null>;
type ForceLogoutHandler = () => void;

/** Set 401/force-logout handlers on every API service so expired token on any request triggers refresh or redirect to login. */
export function setAllUnauthorizedHandlers(
  onUnauthorized: UnauthorizedHandler | null,
  onForceLogout: ForceLogoutHandler | null
): void {
  ALL_API_SERVICES.forEach((svc) => {
    svc.onUnauthorized = onUnauthorized;
    svc.onForceLogout = onForceLogout;
  });
}
